import { FC } from "react";

interface DropdownArrowSVGProps {
    className?: string;
}

const DropdownArrowSVG: FC<DropdownArrowSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="21"
            height="10"
            viewBox="0 0 21 10"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M1.5 1.5L10.3772 8.4045C10.4494 8.46067 10.5506 8.46067 10.6228 8.4045L19.5 1.5"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

export default DropdownArrowSVG;
